function resetMenuState (sidemenuContent) {
  const primaryListItems = document.querySelectorAll('[data-main-nav-sidemenu-list-item]')
  const nestedListItems = document.querySelectorAll('[data-main-nav-sidemenu-nested-list-item]')

  primaryListItems.forEach(primaryListItem => {
    primaryListItem.classList.remove('main-nav__sidemenu-list-item--open')
  })

  nestedListItems.forEach(nestedListItem => {
    nestedListItem.classList.remove('main-nav__sidemenu-list-item-nested--open')
  })

  sidemenuContent.classList.remove('main-nav__sidemenu--nested-menu-open')
}

function headerSideMenuClickEvents (mainNav) {
  const backButton = mainNav.querySelector('[data-main-nav-sidemenu-back]')
  const sidemenuContent = mainNav.querySelector('[data-main-nav-sidemenu]')
  const primaryListItems = mainNav.querySelectorAll('[data-main-nav-sidemenu-list] [data-main-nav-sidemenu-list-item]')

  primaryListItems.forEach(primaryListItem => {
    const nestedList = primaryListItem.querySelector('[data-main-nav-sidemenu-nested-list]')

    if (nestedList) {
      primaryListItem.addEventListener('click', function handlePrimaryListItemClick () {
        this.classList.toggle('main-nav__sidemenu-list-item--open')
      })

      const nestedListItems = nestedList.querySelectorAll('[data-main-nav-sidemenu-nested-list-item]')
      nestedListItems.forEach(nestedListItem => {
        nestedListItem.addEventListener('click', function handleNestedListItemClick (e) {
          e.stopPropagation()

          if (this.firstElementChild.tagName === 'A') return

          mainNav.querySelector('[data-main-nav-sidemenu-back]').classList.add('main-nav__sidemenu-header-back--show')
          this.classList.toggle('main-nav__sidemenu-list-item-nested--open')
          sidemenuContent.classList.add('main-nav__sidemenu--nested-menu-open')
        })
      })

      const level2Lists = nestedList.querySelectorAll('[data-main-nav-sidemenu-nested-list-item-list]')
      level2Lists.forEach(level2List => {
        const level2ListItems = level2List.querySelectorAll('[data-main-nav-sidemenu-nested-list-item-list] li')
        level2ListItems.forEach(level2ListItem => {
          level2ListItem.addEventListener('click', (e) => {
            e.stopPropagation()
          })
        })
      })
    }
  })

  const menuOpeners = mainNav.querySelectorAll('[data-main-menu-opener]')
  menuOpeners.forEach((menuOpener) => {
    menuOpener.addEventListener('change', function handleSidemenuCloseButtonClick () {
      backButton.classList.remove('main-nav__sidemenu-header-back--show')
      resetMenuState(sidemenuContent)
    })
  })

  backButton.addEventListener('click', function handleSidemenuBackButtonClick () {
    const openedNestedLists = mainNav.querySelectorAll('.main-nav__sidemenu-list-item-nested--open')
    const lastOpenedNestedList = openedNestedLists[openedNestedLists.length - 1]

    lastOpenedNestedList.classList.remove('main-nav__sidemenu-list-item-nested--open')
    if (openedNestedLists.length === 1) {
      backButton.classList.remove('main-nav__sidemenu-header-back--show')
    }
    sidemenuContent.classList.remove('main-nav__sidemenu--nested-menu-open')
  })
}

export function setActiveMenuItem () {
  const mainMenuSectionEl = document.querySelector('#js-main-menu-section')
  if (mainMenuSectionEl) {
    const params = new URLSearchParams(window.location.search)
    if (params.has('tab')) {
      if (params.get('tab') === 'my-cars-tab-buying') {
        mainMenuSectionEl.setAttribute('data-section', 'buy')
      }
      if (params.get('tab') === 'my-cars-tab-selling') {
        mainMenuSectionEl.setAttribute('data-section', 'sell-my-car')
      }
    }

    const mainMenuSectionId = mainMenuSectionEl.getAttribute('data-section')
    const activeMenuItems = document.querySelectorAll(`[data-main-menu-section="${mainMenuSectionId}"]`)
    activeMenuItems.forEach((item) => {
      item.classList.add('is-active')
    })
  }
}

export function initHeader () {
  const mainNavs = document.querySelectorAll('[data-main-nav]')
  if (mainNavs.length === 0) return

  mainNavs.forEach((mainNav) => {
    headerSideMenuClickEvents(mainNav)
  })
  setActiveMenuItem()
}
